<template>
    <div>
        <div class="timeline">
            <div class="group"  v-for="(item,index) in items">
                <h2 class="title" v-html="item.title"></h2>
                <div class="item flex" v-bind:class="{ clickable : row.clickable != undefined, first : itemIndex == 0, left : row.owner != undefined && !row.owner  }"
                     v-for="(row,itemIndex) in item.items">
                    <div class="date side">
                        <div @click="triggerClick(index,itemIndex)" class="day" v-html="getDate(row.date)"></div>
                        <div  v-if="row.tags != undefined">
                            <div @click="triggerClick(index,itemIndex)" class="time">
                                <div class="tags"  v-if="row.tags != undefined">
                                    <span class="tag" v-bind:class="tag.color" v-for="tag in row.tags" v-html="tag.title"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="icon" v-bind:class="row.iconColor">
                        <div class="material-icons" v-bind:class="row.iconFlip != undefined && row.iconFlip ? 'flip' : ''" v-html="row.icon"></div>
                    </div>
                    <div class="message side">
                        <div @click="triggerClick(index,itemIndex)"  class="timeline-content" v-bind:class="row.color != undefined ? row.color : ''" v-html="row.message"></div>
                        <div class="subcontent flex-center" v-if="row.user != undefined" v-bind:class="{ left : row.owner != undefined && !row.owner }">
                            <div class="creator flex-center" v-if="row.user != undefined" style="cursor:pointer;"
                                 @click.prevent="$openBottomDrawer('/users/'+row.user.id,'Profile &ndash; '+row.user.name)">
                                <div class="avatar"><img width="15" class="rounded" v-bind:src="row.user.avatar" /></div>
                                <div class="name" v-html="row.user.name"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:30px; margin-top:-25px;" v-if="loading"><div class="loader"></div></div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {
            this.hasPages = this.pages;
        },
        data:function() {
            return {
                page:1,
                hasPages:false,
                loading:false
            }
        },
        props:{
            items:{type:Array,default:function() { return []}},
            pages:{type:Boolean,default:false},
            nextPage:{type:String,default:''}
        },
        methods: {
            getDate(date,format = 'MMM.  Do, h:mma ') {
                return moment(new Date(date)).format(format);
            },
            triggerClick:function(index,itemIndex) {
                var item = this.items[index].items[itemIndex];
                if(item.drawerTrigger != undefined) {
                    this.$openDrawer(item.drawerTrigger);
                }
            }
        },
        mounted:function() {
            var e = this;
            $(function() {
               $('#app-content').on('scroll',function() {
                   var scrollHeight = document.getElementById("app-content").scrollHeight;
                   var scrollTop = $(this).scrollTop();
                   var screenShown = scrollTop + parseFloat($(this).css('height'));
                   if(screenShown >= (scrollHeight - 300)) {
                       if(e.hasPages && e.nextPage != '' && !e.loading) {
                           e.page += 1;
                           e.loading = true;
                           $.get(e.nextPage,{ page: e.page},function(response) {
                               if(response.status == 200) {
                                   if(response.content != '') {
                                       var data = JSON.parse(response.content);
                                       $.each(data,function(_,item){
                                           var found = false;
                                           $.each(e.items,function(_,i){
                                               if(i.title == item.title) {
                                                   found = true;
                                                   $.each(item.items,function(_,value) {
                                                       i.items.push(value);
                                                   });
                                               }
                                           });
                                           if(!found) {
                                               e.items.push(item);
                                           }
                                       });
                                       e.$forceUpdate();
                                       e.loading = false;
                                   } else {
                                       e.hasPages = false;
                                       e.loading = false;
                                   }
                               }
                           })
                       }
                   }
               });
            });
        },
    }
</script>
